<template>
    <section v-if="hasPermissions(['Associate-Position Read','Associate-Position Write', 'Associate-Position Position-Upload'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is a list of Positions. Click "Add Position" to create a new position.
            </p>
        </div>

        <div class="bar-container">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="positions.length && hasPermissions(['Associate-Position Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container__options">
                <UploadOptions
                    :ref="'file_excel'"
                    :empty_format_data="empty_format_data"
                    :excel_file_headers="excel_file_headers"
                    :file_name="'positions_template_file'"
                    @data="upload($event)"
                    v-if="hasPermissions(['Associate-Position Position-Upload'])"
                />
                <button v-if="hasPermissions(['Associate-Position Write'])" class="modal__buttons__item w-auto px-3" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
            </div>
            <div v-if="hasPermissions(['Associate-Position Write'])" class="bar-container__cta">
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>

        <div class="tab-content" v-show="positions.length && hasPermissions(['Associate-Position Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :headers="table_headers"
                                :items="positions"
                                :search="search"
                                :checkable="true"
                                :link="child_href"
                                :updateable="true"
                                @emitToUpdate="modal_update($event)"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion($event)"
        />

        <DeletionMassiveModal
            @objectDeletion="massive_local_emition($event)"
        />

        <FormModal 
            :title="'New Position'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :axios="axios"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal 
            :title="'Position Update'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :axios="axios"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
        />

        <WaitingModal/>

        <UploadSummary
            :breadcrumb="breadcrumb"
            :summary="summary"
            :excel_file_headers="excel_file_headers"
            :excel_data="excel_data"
            :file_name="'positions_falied_template_file'"
        />

        <HelperModal :helps="helps"/>
    </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>
import axios                from    'axios';
import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal         from    '@/components/WaitingModal'
import Resources            from    './resources'
import FormModal            from    './FormModal'
import UpdateModal          from    './UpdateModal'
import DeletionModal        from    '@/components/DeletionModal'
import DeletionMassiveModal from    '@/components/DeletionMassiveModal'
import UploadOptions        from    '@/components/UploadOptions'
import UploadSummary        from    '@/components/UploadSummary'
import HelperModal          from    '@/components/HelperModal'
import 'vuetify/dist/vuetify.min.css'
const number_format = new Intl.NumberFormat("en-US");
import DinamicTable     from    '@/components/DinamicTable'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
export default {

    name:   'Position',

    components:{
        Breadcrumb,
        WaitingModal,
        DeletionModal,
        FormModal,
        UpdateModal,
        DinamicTable,
        DeletionMassiveModal,
        UploadOptions,
        UploadSummary,
        UnauthorizedComponent,
        HelperModal
    },

    data(){
        return {
            notyf,
            axios,
            child_href:         '/associate-positions/',
            user:               this.get_user(),
            title_page:         'Positions',
            rest_api:           `positions`,
            table_headers:      Resources.table_headers,
            breadcrumb:         Resources.breadcrumb,
            add_btn:            'Add Position',
            single_select:      false,
            table_selection:    [],
            search:             '',
            global_index:       0,
            single_object:      {},
            positions:          [],
            array_options:      {},
            select_ids:         [],
            excel_file_headers:     Resources.excel_file_headers,
            empty_format_data:      Resources.empty_format_data,
            excel_fields_required:  Resources.excel_fields_required,
            summary:                [],
            excel_data:             [],
            helps:                Resources.helps
        }
    },

    methods:{

        format_number(value)
        {
            return value !== undefined ? number_format.format(value): '';
        },
        
        unshift_object(new_object)
        {
            this.positions.unshift(new_object)
        },

        splice_object(splicing_object)
        {
            this.positions.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        form_modal()
        {
            if(!this.user.has_facility)
            {
                notyf.error('There is not exists a facility yet')
                return false
            }
            window.$('#static').modal('show')
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.positions[index]
            window.$('#static-deletion').modal('show')
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = this.positions[index]
            window.$('#static-update').modal('show')
        },
      
        fill_data(data)
        {
            this.positions = data.positions
            this.array_options = {
                group_id: data.groups
            }
        },

        trashing(index)
        {
            this.positions.splice(index, 1)
        },

        massive_modal_delete()
        {
            this.select_ids = this.positions.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let json_request = {
                ids:         this.select_ids,
            }

            let sendingMassive = await this.massive_delete(json_request)

            if(sendingMassive)
            {
                this.select_ids.forEach( item =>
                {
                    const index = this.positions.findIndex(value => value.id == item)
                    if(index > -1)
                    {
                        this.positions.splice(index, 1)
                    }
                })
                this.select_ids = []
            }
        },

        async upload(data)
        {
            const send_data = [];
            this.excel_data = []

            for ( const value of data ) {
                const entity = {}

                for (const prop in this.excel_file_headers) {
                    entity[this.excel_file_headers[prop]] = this.parse_boolean(value[prop])
                }

                this.excel_data.push({... entity})

                const group = this.array_options.group_id.find(item => item.name == entity.group_id)
                entity.group_id = group ? group.id : null

                send_data.push(entity)
            }
            
            this.loader(true)
            const response = await this.post(`${this.rest_api}/massive`, { positions: send_data })
            this.loader()

            if(response.status)
            {
                notyf.success('Success!')
                this.summary = response.data.summary
                window.$('#upload-summary').modal('show')

                for (const position of response.data.positions) {
                    this.unshift_object(position);
                }
            }
            else
            {
                this.error_handling(response)
            }
           
            this.$refs.file_excel.clear_data()
        },
    },

    async mounted()
    {
        if(this.hasPermissions(['Associate-Position Read','Associate-Position Write', 'Associate-Position Position-Upload']))
        {
            await this.api_request()
        }
    },

    computed:
    {
        selected()
        {
            const bool = this.positions.filter(item => item.checked)
            return Boolean(bool.length)
        }
    }
}
</script>